import { PendoAttributes } from 'src/components/PendoTracker/types';
import { IAccountService, AccountSettings } from '../account.service';
import { IUserMetricsService } from './user-metrics-service.interface';

export class UserPendoMetricsService implements IUserMetricsService<PendoAttributes> {
  public constructor(private cookies: any, private accountService: IAccountService) {}

  async fetchTrackedAttributes(): Promise<PendoAttributes> {
    const { userInfo } = this.cookies.getAll();

    const nameFirst = userInfo?.name.nameFirst || '';
    const nameLast = userInfo?.name.nameLast || '';

    const visitor: PendoAttributes['visitor'] = {
      id: userInfo?.id || '',
      email: userInfo?.emailAddress || '',
      firstName: nameFirst,
      lastName: nameLast,
      type: 'Patient',
      url: window.location.href
    };

    let accountInfo = {} as AccountSettings;

    if(userInfo?.accountId) {
      accountInfo = await this.accountService.getAccountSettings(userInfo.accountId);
    }

    const account: PendoAttributes['account'] = {
      id: userInfo?.accountId || '',
      name: accountInfo?.companyName || '',
      timezone: accountInfo?.timezone || '',
      city: accountInfo?.postalAddress.city || '',
      street: accountInfo?.postalAddress.street || '',
      street2: accountInfo?.postalAddress.street2 || '',
      postalCode: accountInfo?.postalAddress.zipcode || '',
      stateCode: accountInfo?.postalAddress.state || '',
      countryCode: accountInfo?.postalAddress.country || ''
    };

    return {
      account,
      visitor
    };
  }
}
